import "./Alpha.scss";
import ContactBtn from "../../../components/ContactBtn/ContactBtn";
import { alphaImg } from "../../../service/image";

const Alpha = ({ setOpenModal }) => {
  return (
    <section id="alpha" className="alpha">
      <div className="container">
        <div className="alpha__items row">
          <div className="alpha__item">
            <p>Hi !</p>
            <h1>I’m Erik Yeghiazaryan. a Full Stack Web Developer</h1>
            <p>
              Full Stack developer + DevOps based in Marseille, France I’am
              coding with a clean and beautiful problem solving in mind.
            </p>

            <div className="alpha__btns">
              <ContactBtn setOpenModal={setOpenModal} />

              <a
                className="download__cv"
                href="/files/About-me.pdf"
                download="About-me.pdf"
              >
                Download CV
              </a>
            </div>
          </div>
          <div className="alpha__img">
            <img src={alphaImg} alt="Alpha img" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Alpha;
